import React from "react";
import PostBox from "../components/detail/PostBox";
import Layout from "../components/global/Layout";

const PostDetail = () => {

    return (
      <Layout>
        <PostBox />
      </Layout>
    )
  }
  
export default PostDetail;